import { gql } from "@apollo/client";

export const EMPLOYEES = gql`
  query employees {
    employees {
      id
      eid
      name
      phone
      email
      role
      created_at
      updated_at
      date_of_birth
      place_of_birth
      company_id
      status
      expired_date
    }
  }
`;

export const SEARCH_EMPLOYEE = gql`
  query searchEmployees($name: String) {
    searchEmployees(name: $name) {
      id
      eid
      name
      phone
      email
      role
      created_at
      updated_at
      date_of_birth
      place_of_birth
      company_id
      status
      expired_date
    }
  }
`;

export const CREATE_EMPLOYEE = gql`
  mutation createEmployee($data: InEmployee!) {
    createEmployee(data: $data) {
      id
      eid
      name
      phone
      email
      role
      created_at
      updated_at
      date_of_birth
      place_of_birth
      company_id
      status
      expired_date
    }
  }
`;

export const UPDATE_EMPLOYEE = gql`
  mutation updateEmployee($eid: String!, $data: InEmployee!) {
    updateEmployee(eid: $eid, data: $data) {
      id
      eid
      name
      phone
      email
      role
      created_at
      updated_at
      date_of_birth
      place_of_birth
      company_id
      status
      expired_date
    }
  }
`;

export const GET_EMPLOYEE_BY_EID = gql`
  query getEmployeeByEid($eid: String) {
    getEmployeeByEid(eid: $eid) {
      id
      name
      status
      place_of_birth
      phone
      date_of_birth
      email
      role
      expired_date
      image
    }
  }
`;

export const GET_EMPLOYEE_TARGET = gql`
  query getEmployeeTarget($eid: String!, $year: Int!) {
    getEmployeeTarget(eid: $eid, year: $year) {
      invoice_profit
      pending_profit
      personal_debt
      selling_profit
      total_profit
      company_profit
      total_platform_fee_bill
    }
  }
`;

export const GET_TOTAL_CUSTOMER = gql`
  query getTotalCustomer($eid: String!, $year: Int!) {
    getTotalCustomer(eid: $eid, year: $year) {
      id
      name
      total
    }
  }
`;

export const GET_TOTAL_EMPLOYEE_DEBT = gql`
  query findDebtsByEmployeeId($employee_id: ID!, $year: Int!) {
    findDebtsByEmployeeId(employee_id: $employee_id, year: $year) {
      data {
        amount
        description
        transaction_date
        employee {
          name
        }
      }
      total
    }
  }
`;

export const GET_TOTAL_SCHOOL_DEBT = gql`
  query findSchoolDebtsByEmployeeId($employee_id: ID!, $year: Int!) {
    findSchoolDebtsByEmployeeId(employee_id: $employee_id, year: $year) {
      data {
        client {
          name
        }
        grand_total
        id
        outstanding_payment
        status
        total_payment
        total_sales
        transaction_date
        employee {
          name
        }
      }
      total
    }
  }
`;
